import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1TeamSnapshotsList: build.query<
      ApiPortalV1TeamSnapshotsListApiResponse,
      ApiPortalV1TeamSnapshotsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    apiPortalV1TeamSnapshotsCreate: build.mutation<
      ApiPortalV1TeamSnapshotsCreateApiResponse,
      ApiPortalV1TeamSnapshotsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/`,
        method: "POST",
        body: queryArg.teamSnapshot,
        params: {
          assessment_period: queryArg.assessmentPeriod,
        },
      }),
    }),
    apiPortalV1TeamSnapshotsRetrieve: build.query<
      ApiPortalV1TeamSnapshotsRetrieveApiResponse,
      ApiPortalV1TeamSnapshotsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/${queryArg.id}/`,
      }),
    }),
    apiPortalV1TeamSnapshotsUpdate: build.mutation<
      ApiPortalV1TeamSnapshotsUpdateApiResponse,
      ApiPortalV1TeamSnapshotsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.teamSnapshot,
      }),
    }),
    apiPortalV1TeamSnapshotsPartialUpdate: build.mutation<
      ApiPortalV1TeamSnapshotsPartialUpdateApiResponse,
      ApiPortalV1TeamSnapshotsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedTeamSnapshot,
      }),
    }),
    apiPortalV1TeamSnapshotsDestroy: build.mutation<
      ApiPortalV1TeamSnapshotsDestroyApiResponse,
      ApiPortalV1TeamSnapshotsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1TeamSnapshotsDeleteSnapshotsDestroy: build.mutation<
      ApiPortalV1TeamSnapshotsDeleteSnapshotsDestroyApiResponse,
      ApiPortalV1TeamSnapshotsDeleteSnapshotsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/delete-snapshots/`,
        method: "DELETE",
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1TeamSnapshotsLeadersRetrieve: build.query<
      ApiPortalV1TeamSnapshotsLeadersRetrieveApiResponse,
      ApiPortalV1TeamSnapshotsLeadersRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/leaders/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1TeamSnapshotsMineRetrieve: build.query<
      ApiPortalV1TeamSnapshotsMineRetrieveApiResponse,
      ApiPortalV1TeamSnapshotsMineRetrieveApiArg
    >({
      query: () => ({ url: `/api/portal/v1/team-snapshots/mine/` }),
    }),
    apiPortalV1TeamSnapshotsWithMetricsRetrieve: build.query<
      ApiPortalV1TeamSnapshotsWithMetricsRetrieveApiResponse,
      ApiPortalV1TeamSnapshotsWithMetricsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/team-snapshots/with-metrics/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          include_extended: queryArg.includeExtended,
          leader_id: queryArg.leaderId,
          metric_type: queryArg.metricType,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1TeamSnapshotsListApiResponse =
  /** status 200  */ PaginatedTeamSnapshotListRead;
export type ApiPortalV1TeamSnapshotsListApiArg = {
  /** Filter snapshots by assessment period id (query parameter). */
  assessmentPeriodId?: number;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type ApiPortalV1TeamSnapshotsCreateApiResponse =
  /** status 201  */ TeamSnapshotRead;
export type ApiPortalV1TeamSnapshotsCreateApiArg = {
  /** AssessmentPeriod id to snapshot (required in body but documented here for clarity) */
  assessmentPeriod: number;
  teamSnapshot: TeamSnapshot;
};
export type ApiPortalV1TeamSnapshotsRetrieveApiResponse =
  /** status 200  */ TeamSnapshotRead;
export type ApiPortalV1TeamSnapshotsRetrieveApiArg = {
  /** A unique integer value identifying this team snapshot. */
  id: number;
};
export type ApiPortalV1TeamSnapshotsUpdateApiResponse =
  /** status 200  */ TeamSnapshotRead;
export type ApiPortalV1TeamSnapshotsUpdateApiArg = {
  /** A unique integer value identifying this team snapshot. */
  id: number;
  teamSnapshot: TeamSnapshot;
};
export type ApiPortalV1TeamSnapshotsPartialUpdateApiResponse =
  /** status 200  */ TeamSnapshotRead;
export type ApiPortalV1TeamSnapshotsPartialUpdateApiArg = {
  /** A unique integer value identifying this team snapshot. */
  id: number;
  patchedTeamSnapshot: PatchedTeamSnapshot;
};
export type ApiPortalV1TeamSnapshotsDestroyApiResponse = unknown;
export type ApiPortalV1TeamSnapshotsDestroyApiArg = {
  /** A unique integer value identifying this team snapshot. */
  id: number;
};
export type ApiPortalV1TeamSnapshotsDeleteSnapshotsDestroyApiResponse =
  /** status 200  */ {
    [key: string]: any;
  };
export type ApiPortalV1TeamSnapshotsDeleteSnapshotsDestroyApiArg = {
  /** Assessment period id to delete snapshots for. */
  assessmentPeriodId: number;
};
export type ApiPortalV1TeamSnapshotsLeadersRetrieveApiResponse =
  /** status 200  */ {
    [key: string]: any;
  };
export type ApiPortalV1TeamSnapshotsLeadersRetrieveApiArg = {
  /** Assessment period id to filter the snapshot leaders list. */
  assessmentPeriodId: number;
};
export type ApiPortalV1TeamSnapshotsMineRetrieveApiResponse =
  /** status 200  */ TeamSnapshotRead;
export type ApiPortalV1TeamSnapshotsMineRetrieveApiArg = void;
export type ApiPortalV1TeamSnapshotsWithMetricsRetrieveApiResponse =
  /** status 200  */ {
    [key: string]: any;
  };
export type ApiPortalV1TeamSnapshotsWithMetricsRetrieveApiArg = {
  /** Assessment period id to filter snapshots and metrics */
  assessmentPeriodId: number;
  /** If true, include aggregated metrics for the team's subtree (children recursively) */
  includeExtended?: boolean;
  /** Filter to snapshots for teams this leader leads and their descendant teams (only applies if include_extended=true). Does not include ancestor teams. */
  leaderId?: number;
  /** Metric type (see core.models.metric.MetricType) to include for each team */
  metricType: number;
};
export type TeamSnapshot = {};
export type EmployeeTeamSnapshot = {};
export type EmployeeTeamSnapshotRead = {
  id: number;
  team_snapshot: number;
  employee: number;
  employee_email: string | null;
  employee_first_name: string | null;
  employee_last_name: string | null;
  membership_created_at: string | null;
  snapshot_created_at: string;
};
export type TeamSnapshotRead = {
  id: number;
  assessment_period: number;
  organization: number;
  team_id: number | null;
  name: string;
  color: string | null;
  leader_id: number | null;
  leader_email: string | null;
  leader_first_name: string | null;
  leader_last_name: string | null;
  leader_can_invite: boolean;
  sort_order: number | null;
  parent_id: number | null;
  team_created_at: string | null;
  team_updated_at: string | null;
  snapshot_created_at: string;
  members: EmployeeTeamSnapshotRead[];
};
export type PaginatedTeamSnapshotList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TeamSnapshot[];
};
export type PaginatedTeamSnapshotListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TeamSnapshotRead[];
};
export type PatchedTeamSnapshot = {};
export type PatchedTeamSnapshotRead = {
  id?: number;
  assessment_period?: number;
  organization?: number;
  team_id?: number | null;
  name?: string;
  color?: string | null;
  leader_id?: number | null;
  leader_email?: string | null;
  leader_first_name?: string | null;
  leader_last_name?: string | null;
  leader_can_invite?: boolean;
  sort_order?: number | null;
  parent_id?: number | null;
  team_created_at?: string | null;
  team_updated_at?: string | null;
  snapshot_created_at?: string;
  members?: EmployeeTeamSnapshotRead[];
};
export const {
  useApiPortalV1TeamSnapshotsListQuery,
  useApiPortalV1TeamSnapshotsCreateMutation,
  useApiPortalV1TeamSnapshotsRetrieveQuery,
  useApiPortalV1TeamSnapshotsUpdateMutation,
  useApiPortalV1TeamSnapshotsPartialUpdateMutation,
  useApiPortalV1TeamSnapshotsDestroyMutation,
  useApiPortalV1TeamSnapshotsDeleteSnapshotsDestroyMutation,
  useApiPortalV1TeamSnapshotsLeadersRetrieveQuery,
  useApiPortalV1TeamSnapshotsMineRetrieveQuery,
  useApiPortalV1TeamSnapshotsWithMetricsRetrieveQuery,
} = injectedRtkApi;
